// extracted by mini-css-extract-plugin
export default {"some":"NotFoundPage_some__NbyDQ","some__pageName":"NotFoundPage_some__pageName__DvC73","some__content":"NotFoundPage_some__content__OP70f"};